var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { format } from "date-fns";
import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import styled from "styled-components";
import { Text, tombac } from "tombac";
import { useReleaseNotesQuery } from "../legolandApi";
import { ReleaseNoteStyles } from "./ReleaseNoteStyles";
import { useReleaseNotesMarkRead } from "./releaseNotesHooks";
export var ReleaseNotes = function (_a) {
    var _b;
    var _c = _a.markRead, markRead = _c === void 0 ? false : _c, productId = _a.productId;
    var rnQuery = useReleaseNotesQuery({ productId: productId });
    var markReleaseNotesAsRead = useReleaseNotesMarkRead({ productId: productId });
    useEffect(function () {
        if (markRead && rnQuery.data) {
            markReleaseNotesAsRead(rnQuery.data);
        }
    }, [markRead, rnQuery.data]);
    if (rnQuery.isError) {
        return (React.createElement(Text, { "$alignSelf": "center", "$m": "0 auto", variant: "danger", style: { textAlign: "center" } }, "Error loading release notes."));
    }
    if (rnQuery.isLoading) {
        return (React.createElement(Text, { "$alignSelf": "center", "$m": "0 auto", variant: "secondary", style: { textAlign: "center" } }, "Loading release notes..."));
    }
    if (!((_b = rnQuery.data) === null || _b === void 0 ? void 0 : _b.length)) {
        return React.createElement(Text, null, "No release notes yet.");
    }
    return rnQuery.data.map(function (item) { return (React.createElement(Container, { key: item.id },
        React.createElement(CommunicationHeading, null, format(item.date, "d MMMM yyyy")),
        React.createElement(ReleaseNoteStyles, { as: ReactMarkdown, components: {
                h1: "h3",
                h2: "h4",
                h3: "h5",
                h4: "h6",
                h5: "h6",
            }, rehypePlugins: [[rehypeRaw]], remarkPlugins: [remarkGfm] }, item.message))); });
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:not(:first-of-type) {\n    border-top: ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n  }\n"], ["\n  margin: ", ";\n\n  &:first-child {\n    margin-top: 0;\n  }\n\n  &:not(:first-of-type) {\n    border-top: ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n  }\n"])), tombac.parse("3sp 0 0"), tombac.parse("1u solid --neutral-400"), tombac.space(3), tombac.space(3));
var CommunicationHeading = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: ", ";\n  ", "\n"], ["\n  margin: ", ";\n  ", "\n"])), tombac.parse("0 0 2sp"), tombac.altText({ fontSize: 20, fontWeight: 700 }));
var templateObject_1, templateObject_2;
//# sourceMappingURL=ReleaseNotes.js.map